import { loggedInBrandLeanProductTilesRequest, getEstimatedClientSize, searchBrandProductsFiltersRequestFromProductTilesRequest, getPageNumber, getPageSize } from "@faire/retailer-shared/search/loggedInBrandLeanProductTilesRequest";
import getPublishedBrandProductCollectionMetadata from "@faire/web-api--source/api/brand/brandToken/published-product-collection-metadata/get";
import { getQueryKey as getQueryKeyPublishedBrandProductCollectionMetadata } from "@faire/web-api--source/api/brand/brandToken/published-product-collection-metadata/get-hooks";
import searchProductsFromBrandFilters from "@faire/web-api--source/api/v2/search/products/from-brand/filters/post";
import { getQueryKey_escape_hatch as getQueryKeyProductsFromBrandFilters } from "@faire/web-api--source/api/v2/search/products/from-brand/filters/post-hooks";
import searchProductsFromBrand from "@faire/web-api--source/api/v2/search/products/from-brand/post";
import { getQueryKey_escape_hatch as getQueryKeyProductsFromBrand } from "@faire/web-api--source/api/v2/search/products/from-brand/post-hooks";
import { getSettingShouldDisplayRetrievalAndRankingDebugInfo } from "@faire/retailer-visitor-shared/settings/getSettingShouldDisplayRetrievalAndRankingDebugInfo";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getBrandViewUseQueryArgs } from "@faire/retailer-visitor-shared/views/brand/hooks/useFetchCachedBrandView";
export function preloadBrandPageLoggedIn(brandToken, queryParams, queryClient) {
    queryClient.prefetchQuery(getBrandViewUseQueryArgs(brandToken));
    var _getBrandProductsUseQueryArgs = getBrandProductsUseQueryArgs(brandToken, queryParams), collectionsQueryKey = _getBrandProductsUseQueryArgs.collectionsQueryKey, collectionsQueryFn = _getBrandProductsUseQueryArgs.collectionsQueryFn, productsQueryKey = _getBrandProductsUseQueryArgs.productsQueryKey, productsQueryFn = _getBrandProductsUseQueryArgs.productsQueryFn, productFiltersQueryKey = _getBrandProductsUseQueryArgs.productFiltersQueryKey, productFiltersQueryFn = _getBrandProductsUseQueryArgs.productFiltersQueryFn, staleTime = _getBrandProductsUseQueryArgs.staleTime;
    queryClient.prefetchQuery({
        queryKey: collectionsQueryKey,
        queryFn: collectionsQueryFn,
        staleTime: staleTime
    });
    queryClient.prefetchQuery({
        queryKey: productsQueryKey,
        queryFn: productsQueryFn,
        staleTime: staleTime
    });
    queryClient.prefetchQuery({
        queryKey: productFiltersQueryKey,
        queryFn: productFiltersQueryFn,
        staleTime: staleTime
    });
}
export function getBrandProductsUseQueryArgs(brandToken, queryParams) {
    var clientSize = getEstimatedClientSize();
    var productsRequest = loggedInBrandLeanProductTilesRequest(queryParams, clientSize, brandToken, UserStore.get().user, getSettingShouldDisplayRetrievalAndRankingDebugInfo());
    var filtersRequest = searchBrandProductsFiltersRequestFromProductTilesRequest(productsRequest);
    var collectionsQueryKey = getQueryKeyPublishedBrandProductCollectionMetadata(brandToken, {
        page: getPageNumber(queryParams),
        pageSize: getPageSize(clientSize)
    });
    var productsQueryKey = getQueryKeyProductsFromBrand(productsRequest);
    var productFiltersQueryKey = getQueryKeyProductsFromBrandFilters(filtersRequest);
    return {
        collectionsQueryKey: collectionsQueryKey,
        collectionsQueryFn: function() {
            return getPublishedBrandProductCollectionMetadata(brandToken, {
                page: getPageNumber(queryParams),
                pageSize: getPageSize(clientSize)
            });
        },
        productsQueryKey: productsQueryKey,
        productsQueryFn: function() {
            return searchProductsFromBrand(productsRequest);
        },
        productFiltersQueryKey: productFiltersQueryKey,
        productFiltersQueryFn: function() {
            return searchProductsFromBrandFilters(filtersRequest);
        },
        queryKeyString: JSON.stringify([
            collectionsQueryKey,
            productsQueryKey
        ]),
        staleTime: 1000 * 60 * 5
    };
}
